import React from "react";

const ClaimHistory = ({ claimsData, currentClaimsItems, view }) => {
  const formatTimestamp = (timestamp) => {
    const timestampToNumber = Number(timestamp);

    const date = new Date(timestampToNumber * 1000);

    const pad = (n) => String(n).padStart(2, "0");

    const day = pad(date.getDate());
    const month = pad(date.getMonth() + 1); // months are 0-indexed
    const year = date.getFullYear();

    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());

    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  };

  return view === "table" ? (
    <tbody>
      {claimsData.length > 0 &&
        currentClaimsItems?.map((claimTrx) => (
          <tr key={claimTrx.transactionHash}>
            <td>
              <span className="midweight">
                {formatTimestamp(claimTrx.blockTimestamp)}
              </span>{" "}
              {/* 21:15:53 */}
            </td>
            <td>
              {claimTrx.airdropped / 10 ** 18}{" "}
              <span className="dullpara">RAIN</span>
            </td>
            <td>
              <a
                className="hashlink"
                href={`https://arbiscan.io/tx/${claimTrx.transactionHash}`}
                target="_blank"
              >
                {claimTrx.transactionHash.slice(0, 5)}...
                {claimTrx.transactionHash.slice(-3)}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="14"
                  viewBox="0 0 15 14"
                  fill="none"
                >
                  <path
                    d="M7.91699 6.41666L12.7003 1.63333"
                    stroke="#E1EFF5"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M13.1667 3.96666V1.16666H10.3667"
                    stroke="#E1EFF5"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M6.75 1.16666H5.58333C2.66667 1.16666 1.5 2.33332 1.5 5.24999V8.74999C1.5 11.6667 2.66667 12.8333 5.58333 12.8333H9.08333C12 12.8333 13.1667 11.6667 13.1667 8.74999V7.58332"
                    stroke="#E1EFF5"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </a>
            </td>
          </tr>
        ))}
    </tbody>
  ) : (
    <>
      {claimsData.length > 0 &&
        currentClaimsItems?.map((claimTrx) => (
          <div className="innerbox" key={claimTrx.transactionHash}>
            <div className="boxinner">
              <h6 className="mainhead">TIME</h6>
              <p className="mainpara">
                {formatTimestamp(claimTrx.blockTimestamp)}
              </p>
            </div>
            <div className="boxinner">
              <h6 className="mainhead">amount</h6>
              <p className="mainpara">
                {" "}
                {claimTrx.airdropped / 10 ** 18}{" "}
                <span className="dullpara">RAIN</span>
              </p>
            </div>
            <div className="boxinner">
              <h6 className="mainhead">hash</h6>
              <p className="mainpara">
                <a
                  className="hashlink"
                  href={`https://arbiscan.io/tx/${claimTrx.transactionHash}`}
                  target="_blank"
                >
                  {claimTrx.transactionHash.slice(0, 5)}...
                  {claimTrx.transactionHash.slice(-3)}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="14"
                    viewBox="0 0 15 14"
                    fill="none"
                  >
                    <path
                      d="M7.91699 6.41666L12.7003 1.63333"
                      stroke="#E1EFF5"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M13.1667 3.96666V1.16666H10.3667"
                      stroke="#E1EFF5"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M6.75 1.16666H5.58333C2.66667 1.16666 1.5 2.33332 1.5 5.24999V8.74999C1.5 11.6667 2.66667 12.8333 5.58333 12.8333H9.08333C12 12.8333 13.1667 11.6667 13.1667 8.74999V7.58332"
                      stroke="#E1EFF5"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </a>
              </p>
            </div>
          </div>
        ))}
    </>
  );
};

export default ClaimHistory;
